export class CustomQueryParams {
    public params: string;

private constructor(){        
    }

public static Create(data: {}) : CustomQueryParams{
        const cqp = new CustomQueryParams();

    cqp.params = JSON.stringify(data);   

    return cqp;
}    
}